import ReferralResults from './ReferralResults'

export default ReferralResults
